module.exports = __webpack_public_path__ + "static/Underdown2-341d2217f86c0ae955de66a19c993bdc.webp";